import ModuleLoadingBase from './ModuleLoadingBaseContainer';
import loadingPage from './HOC/loadingPage';

export default loadingPage(ModuleLoadingBase);
